export const AgentWalletConfigurationLocale = {
  en: {
    'bread-crump-parent': 'System Configuration',
    'bread-crump-current': 'Agent Wallet Configuration',
    'page-title': 'Agent Wallet Configuration',
    'page-subtitle':
      'Only Wallet Admins can view and edit wallet settings for agents using the CRM/MyLead app.',
    MinuteCost: 'Standard call minutes cost',
    MinimumTopUp: 'Minimum top-up limit',
    MaximumTopUp: 'Maximum top-up limit',
    OverdraftEnabled: 'Overdraft',
    OverdraftMinutes: 'Overdraft limit',
    OverdraftWarningMessage: 'Overdraft message',
    LowBalanceThresholds: 'Low balance threshold',
    OverdraftWarningThresholds: 'Overdraft warning threshold',
    NotificationTemplate: 'Notification template editor',
  },
  ar: {
    'bread-crump-parent': 'إعدادات النظام',
    'bread-crump-current': 'إعدادات محفظة الوكيل',
    'page-title': 'إعدادات محفظة الوكيل',
    'page-subtitle':
      'يمكن للمسؤولين المحفظة فقط عرض وتحديث اعدادات المحفظة للوكيلات المستخدمة في التطبيق CRM/MyLead.',
  },
};

export const AgentWalletConfigurationPath = 'AgentWalletConfigurationView';
